/**
 * useUserPreferences
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import UserPreferencesContext from './user-preferences-context'

const useUserPreferences = () => {
  const context = useContext(UserPreferencesContext)
  return context
}

export default useUserPreferences
